import React, {useCallback, useEffect, useState} from 'react';
import {getWalletTransactions, getConversionData} from './redux/wallet.action';
import {Network} from '../../utils/network';
import {
  conversionMethod,
  isMobile,
  trackMoengageEvent,
} from '../../utils/commonMethods';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  ActivityIndicator,
  Dimensions,
} from 'react-native';
import {Color, globalFontStyle, globalStyle} from '../../assets';
import Colors from '../../assets/Color/Colors';
import TxnCard from './childComponents/txnCard';
import WalletSummary from './childComponents/WalletSummary';
import {connect, useDispatch, useSelector} from 'react-redux';
import {useFocusEffect} from '@react-navigation/native';
import {getUser} from '../Profile/redux/profile.action';
import {INDIA, REST_OF_WORLD} from '../../utils/constants';
import {SafeAreaView, useSafeAreaInsets} from 'react-native-safe-area-context';
import Header from '../../commonComponents/Header';
import {globalImport} from '../../common/globalImports';
import WebWallet from './childComponents/WebWallet';
import Transaction from './childScreens/Transaction';
import FormTextLabel from '../../commonComponents/FormTextLabel';
import {
  globalConfigurableData,
  GlobalScreens,
} from '../../utils/globalConstant';
import TransactionDrawer from '../../commonComponents/TransactionDrawer';
import ProtectedRoute from '../../commonComponents/ProtectedRoute';

const Wallet = ({
  navigation,
  route,
  getWalletTransactions,
  walletTransactionData,
  getConversionData,
  conversionData,
  getUser,
}) => {
  const rechargeAmount = route?.params?.rechargeAmount;
  const dispatch = useDispatch();
  const onShowAllTxn = () => {
    navigation.navigate('WalletStack', {screen: 'Transaction'});
  };
  const insets = useSafeAreaInsets();

  const [conversionMessage, setConversationMessage] = useState("");
  const [showFaq, setShowFaq] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [showTransactionDrawer, setShowTransactionDrawer] = useState(false);

  let userInfo = useSelector(({profile}) => profile?.profileData);
  const region = userInfo?.region_code;

  useFocusEffect(
    React.useCallback(() => {
      if (region) {
        if (region !== INDIA) {
          getConversionData();
        }
        getWalletTransactions({
          limit: 10,
          page: 1,
          oldest: 0,
        });
        getUser();
      }
    }, [region]),
  );

  useEffect(() => {
    setConversationMessage(conversionMethod(conversionData));
  }, [conversionData]);

  const handleTransactionClick = (transaction) => {
    setSelectedTransaction(transaction);
    setShowTransactionDrawer(true);
  };

  const handleDrawerClose = () => {
    setShowTransactionDrawer(false);
    setSelectedTransaction(null);
  };

  return (
    <View
      style={[
        {
          // backgroundColor: Color.bgWhite,

          paddingTop: insets.top,
          //paddingBottom: insets.bottom,
          paddingLeft: insets.left,
          paddingRight: insets.right,
        },
        isMobile() ? globalStyle.scroll_webFix : {},
      ]}>
      <ScrollView
        contentContainerStyle={{flexGrow: 1}}
        showsVerticalScrollIndicator={false}>
        {!isMobile() ? (
          <Header selected={'Wallet'} isBackgroundColor={true} backGroundColor={Color.bgWhite} />
        ) : (
          <View style={[globalStyle.headerContainer, { backgroundColor: Color.bgWhite }]}>
            <FormTextLabel
              labelStyles={[
                {
                  ...globalFontStyle.appBlueHead,
                  color: globalConfigurableData.primaryTextColor1,
                },
              ]}
              label={'Wallet'}></FormTextLabel>
          </View>
        )}
        <View style={{flexDirection: 'row'}}>
          <View style={{paddingHorizontal: 16, flex: 1}}>
            {typeof userInfo?.deposits === 'number' ? (
              <WalletSummary
                navigation={navigation}
                conversionData={conversionData}
                showFaq={showFaq}
                setShowFaq={setShowFaq}
                conversionMessage={conversionMessage}
              />
            ) : (
              <ActivityIndicator
                size="large"
                color={globalConfigurableData.loaderColor}
              />
            )}
            <View style={styles.recentPassbookBlk}>
              <FormTextLabel
                labelStyles={styles.passbookHeading}
                label={'My Transactions'}
              />
              {isMobile() &&
              walletTransactionData &&
              walletTransactionData.length > 0 ? (
                <TouchableOpacity onPress={onShowAllTxn}>
                  <FormTextLabel
                    labelStyles={styles.seeAllTxn}
                    label={'See all'}
                  />
                </TouchableOpacity>
              ) : null}
            </View>
            {isMobile() ? (
              <ScrollView showsVerticalScrollIndicator={false}>
                {walletTransactionData && walletTransactionData.length
                  ? walletTransactionData.slice(0, 3).map((item, index) => {
                      return <TxnCard key={item.id} transaction={item} />;
                    })
                  : null}
              </ScrollView>
            ) : (
              <View style={{marginBottom: 200}}>
                <Transaction onTransactionClick={handleTransactionClick} />
              </View>
            )}
          </View>
          {!isMobile() && (
            <View style={{marginLeft: 30, flex: 0.5, marginTop: 20}}>
              <WebWallet
                rechargeAmount={rechargeAmount}
                conversionMessage={conversionMessage}
              />
            </View>
          )}
        </View>
      </ScrollView>

      {!isMobile() && (
        <TransactionDrawer
          open={showTransactionDrawer}
          onClose={handleDrawerClose}
          transaction={selectedTransaction?.transactionData}
          typeTxn={selectedTransaction?.type}
        />
      )}
    </View>
  );
};

const mapStateToProps = ({wallet}) => ({
  loading: wallet.loading,
  errors: wallet.errors,
  walletTransactionData: wallet.walletTransactionData,
  conversionData: wallet.conversionData,
});

const mapDispatchToProps = {
  getWalletTransactions,
  getConversionData,
  getUser,
};

const WrappedWallet = (props) => (
  <ProtectedRoute>
    <Wallet {...props} />
  </ProtectedRoute>
);

export default connect(mapStateToProps, mapDispatchToProps)(WrappedWallet);

const styles = StyleSheet.create({
  walletContainer: {
    backgroundColor: globalConfigurableData.globalThemeColor,
    flex: 1,
    paddingHorizontal: 16,
  },
  recentPassbookBlk: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginVertical: 20,
  },
  seeAllTxn: {
    ...globalFontStyle.appFontSubTextBold,
    color: GlobalScreens.Wallet.highlightColor,
    textDecorationLine: 'underline',
  },
  passbookHeading: {
    ...globalFontStyle.appFontTitle,
    color: globalConfigurableData.primaryTextColor1,
  },
  creditAvaialableTxt: {
    ...globalFontStyle.appFontSmallTextBold,
    color: globalConfigurableData.tertiaryTextColor1,
  },
  creditsAmt: {
    ...globalFontStyle.appFontTitleHead,
    color: globalConfigurableData.primaryTextColor1,
  },
  modalStyle: {
    width: Dimensions.get('window').width - 100,
    borderRadius: 12,
    padding: 0,
  },
});
